import React from "react";


const IdentityBusiness = ({identityDocuments}) => {
    
  return ( 
    
    <section className="py-20 sm:py-[40px]">
      <div className="mx-auto w-full container px-3 md:py-2 xm:py-2 md:px-3">
        <div className="max-w-[1280px] mx-auto w-full">
          <div className="flex justify-center gap-x-5 sm:gap-0 sm:flex-col mx-auto w-full">
                <div className="w-full sm:w-full">
                    <h2 className="text-xxl text-black text-center font-bold mb-5">
                      Identity & Business Address Verification Documents 
                    </h2>
                    <div className="flex justify-center sm:justify-between flex-wrap gap-x-5 sm:gap-0 mx-auto w-full border-b-[1px] border-dashed border-[#D9D9D9]">
                      {identityDocuments.documents?.map((items) => {
                        return (
                        <div className="w-[30%] sm:w-[48%] mb-5 sm:mb-3 bg-white text-center sm:text-left" key={items?.id}>
                          <h3 className="text-base2 text-[#3C3C3C]">
                            {items?.heading}
                          </h3>
                        </div>
                        );
                      })}
                    </div>
                    <div className="flex justify-center sm:flex-col mx-auto w-full mt-[60px] sm:mt-[30px]">
                      <div className="w-[50%] sm:w-full text-right border-r-[2px] border-solid border-[#0982FF] py-1 pr-[20px] sm:border-r-0 sm:text-left sm:pr-0 sm:border-b-[2px]">
                        <p className="text-base2 text-[#3C3C3C]">Rate of Interest </p>
                        <p className="text-[22px] text-[#3C3C3C]" dangerouslySetInnerHTML={{__html:identityDocuments.roi.text}}/>
                      </div>

                      <div className="w-[50%] sm:w-full text-left py-1 pl-[20px] sm:pl-0">
                        <p className="text-base2 text-[#3C3C3C]">Stamp Duty </p>
                        <p className="text-[22px] text-[#3C3C3C]">As per applicable  <strong> laws of the state </strong> </p>
                      </div>
                    </div>
                </div>
          </div>
        </div>
      </div> 
    </section>
  );
};

export default IdentityBusiness;
